var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.518,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.003 24a.941.941 0 01-.855-.493.9.9 0 010-.986L12.904.493a.987.987 0 011.71 0L27.37 22.521a.9.9 0 010 .986.941.941 0 01-.855.493zM13.89 9.14a.956.956 0 00-.986.986v5.392a.987.987 0 101.973 0v-5.392a.956.956 0 00-.986-.986zm0 11.014a.956.956 0 10-.707-.279.958.958 0 00.707.278z",
    fill: "#f73c3c"
  })));
}
export default SvgErrorAndroid;